import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
    article_categories_container: {
        display: 'flex',
        flexDirection: 'column',
    },
    article_categories_table: {
        display: 'flex',
        flexDirection: 'column',
    },
    elements_container: {},
    article_category_info_container: {
        position: 'relative',
        marginTop: '4px',
        display: 'grid',
        gridTemplateColumns: '250px auto 50px',
        backgroundColor: theme.palette.common.white,
        borderRadius: 4,
        padding: 8,
        border: `1px solid ${theme.palette.grey["400"]}`,
        borderLeft: `8px solid ${theme.palette.success.light}`,
        "&:hover": {
            backgroundColor: `${theme.palette.grey[200]}`,
            cursor: 'pointer',
            border: `1px solid ${theme.palette.secondary.light}`,
            borderLeft: `8px solid ${theme.palette.secondary.light}`,
        }
    },
    article_category_info_container_small: {
        position: 'relative',
        marginTop: '4px',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
        placeItems: 'stretch',
        rowGap: 16,
        columnGap: 16,
        backgroundColor: theme.palette.common.white,
        borderRadius: 4,
        padding: 8,
        border: `1px solid ${theme.palette.grey["400"]}`,
        borderLeft: `8px solid ${theme.palette.success.light}`,
    },
    inactive: {
        borderLeft: `8px solid ${theme.palette.grey["300"]}`,
        backgroundColor: `${theme.palette.grey["300"]}8c`,
        opacity: '0.8'
    },
    menu_container: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'flex-start',
        "& > *": {
            marginLeft: '4px'
        }
    },
    menu_container_small: {
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        "& > *": {
            marginLeft: '4px'
        }
    },
    filter_container: {
        display: "grid",
        marginTop: '16px',
        gridTemplateColumns: "repeat( auto-fit, minmax(280px, 1fr) )",
        rowGap: 16,
        columnGap: 8,
        "& button": {
            justifySelf: "end"
        }
    },
    tools_container: {
        justifyContent: 'space-between',
    },
    search_btn: {
        justifySelf: 'flex-end'
    },
    number: {
        fontSize: '25px',
        marginLeft: '4px'
    },
    title: {
        fontSize: '12px',
        color: theme.palette.grey["600"],
        fontWeight: 800
    },
    value: {
        fontSize: '18px',
        fontWeight: 600,
        marginTop: '3px'
    },
    without_value: {
        fontSize: '15px',
        color: '#ba000d'
    },
    currency: {
        color: theme.palette.grey[600],
        fontSize: '11px',
        marginLeft: '8px'
    },
    article_category_name_container: {
        display: 'flex',
        alignItems: 'center'
    }
}));

export {useStyles}

